export default {
  type: "nuvei-cards",
  nuvei_card_token: null,
  nuvei_customer_id: null,
  brand: null,
  last4: null,
  expiry_month: null,
  expiry_year: null,
  is_default: false,
  metadata: {},
  relationshipNames: ["customer", "nuveiCustomer", "nuveiTransactions"],
};
